import React, { useEffect } from 'react';
import { useMutation, useQuery, useLazyQuery } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';
import ExecuteScenario from './ExecuteScenario';
import { Button, Typography, InputLabel, Select, Grid, MenuItem, TextField } from '@material-ui/core';
import { DialogForm } from '../../components/DialogForm';
import {
  WORKFLOW_LIST,
  TEST_SCENARIO,
  DELETE_SCENARIO,
  GET_SIMULATION_DATA,
  GET_TEST_EXECUTION_DATA
} from '../graphQL/queries';
import { testScenariocolumns, participantTypes } from './CertificationConfic';
import { PlusCircle, Edit, Trash, PlayCircle } from '@jda/lui-common-icon-library';
import DetailedTable from '../../components/DetailedTable';
import useStyles from './Style';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};

type workflowContentData = {
  content: workflowInfo[];
};

type responseObj = {
  participantInfo: contentData;
};
type contentData = {
  content: specObj[];
};

type specObj = {
  participantCode: string;
  companyName: string;
  primaryEmail: string;
  status: string;
  workflowsCount: number;
  providerCount: number;
  customerCount: number;
};

const CertificationTestScenario = (props: any) => {
  const { simulatedService, participant } = props;
  const classes = useStyles();
  const initialState = {
    testScenarioName: '',
    workflowCode: props?.workflowCode || '',
    stepModalOpen: false,
    description: '',
    items: [] as any,
    operations: [],
    scenarioOperations: [],
    testDataNames: [],
    isDeleteOpen: false,
    addScenarioOpen: false,
    stepExecuteModalOpen: false,
    isEdit: false,
    scenario: { testScenarioName: '', participantType: '', serviceNm: '' },
    scenarios: [],
    fields: [] as any,
    participantType: '',
    activeInex: '',
    rowData: { testScenarioName: '', testStepSequence: [] },
    step: '' as any,
    testScenarioExecutionSeq: [] as any
  };
  const [
    {
      testScenarioName,
      workflowCode,
      description,
      items,
      scenarios,
      operations,
      isDeleteOpen,
      addScenarioOpen,
      participantType,
      isEdit,
      scenario,
      scenarioOperations,
      testDataNames,
      rowData,
      stepExecuteModalOpen,
      activeInex,
      fields,
      step,
      testScenarioExecutionSeq
    },
    setFormField
  ] = React.useState({
    ...initialState
  });
  const inputRef = React.useRef<any>(null);
  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const [testScenario] = useMutation(TEST_SCENARIO);
  const [deleteScenario] = useMutation(DELETE_SCENARIO);
  const { enqueueSnackbar } = useSnackbar();
  const [getExecutionData, { data: executionData, loading: loadingExecutionData }] = useLazyQuery(
    GET_TEST_EXECUTION_DATA,
    {
      fetchPolicy: 'network-only'
    }
  );
  const [getSimulationData, { data: simulationTestData, loading: loadingTestData }] = useLazyQuery(
    GET_SIMULATION_DATA,
    {
      fetchPolicy: 'network-only'
    }
  );

  const fetchTestScenarios = () => {
    testScenario({ variables: { method: 'GET' } }).then((res: any) => {
      let scenarios = [] as any;
      if (workflowCode !== '') {
        const workflow = workflowList.data?.workflow?.content?.filter(
          (item: any) => item.workflowCode === workflowCode
        );
        scenarios = res?.data?.testScenario?.filter((item: any) => item?.serviceNm === workflow?.[0]?.workflowName);
      } else {
        scenarios = res?.data?.testScenario;
      }
      setFormField(prevState => ({ ...prevState, scenarios }));
    });
  };

  useEffect(() => {
    fetchTestScenarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const testScenarioExecutionSeq = executionData?.getExecutionData?.testScenarioExecutionSeq;
    setFormField(prevState => ({ ...prevState, testScenarioExecutionSeq }));
  }, [executionData]);

  useEffect(() => {
    if (simulatedService?.simulatedData?.content?.length > 0) {
      const services = simulatedService?.simulatedData?.content;
      let operations: any = [];
      let testDataNames: any = [];
      for (let i = 0; i < services?.length; i++) {
        const obj = {
          label: services[i].operation,
          value: services[i].operation,
          serviceNm: services[i].serviceNm,
          testDataName: services[i].testDataName
        };
        const testObj = {
          label: services[i].testDataName,
          value: services[i].testDataName,
          serviceNm: services[i].serviceNm
        };
        testDataNames.push(testObj);
        operations.push(obj);
      }
      setFormField(prevState => ({ ...prevState, testDataNames, operations }));
    }
  }, [simulatedService]);

  const scenarioTableActions: any = [
    !participant && {
      icon: () => (
        <Button
          variant="outlined"
          onClick={handleTestScenario}
          data-id="new-operation"
          id="new-operation"
          color="primary"
        >
          Add
        </Button>
      ),
      onClick: () => {},
      position: 'toolbar'
    },
    participant && {
      icon: () => <PlayCircle data-id="execute-operation" />,
      tooltip: 'Execute Scenario',
      onClick: (event: any, rowData: any) => executeScenarioModal(rowData)
    },
    !participant && {
      icon: () => <Edit data-id="edit-operation" />,
      onClick: (event: any, rowData: any) => handleTestScenario(rowData)
    },
    !participant && {
      icon: () => <Trash data-id="delete-participant" />,
      onClick: (event: any, rowData: any) =>
        setFormField(prevState => ({ ...prevState, scenario: rowData, isDeleteOpen: !isDeleteOpen }))
    }
  ];

  const executeScenarioModal = (rowData: any) => {
    getSimulationData({
      variables: {
        search: `serviceNm=${rowData?.serviceNm}`
      }
    });
    getExecutionData({
      variables: {
        participantCode: participant.participantCode,
        testScenarioNm: rowData.testScenarioName,
        serviceNm: rowData.serviceNm
      }
    });
    setFormField(prevState => ({
      ...prevState,
      rowData,
      stepExecuteModalOpen: !stepExecuteModalOpen
    }));
  };

  const handleTestScenario = (rowData: any) => {
    if (rowData?.serviceNm && rowData?.testScenarioName) {
      const testStepSequences = rowData?.testStepSequence?.map((test: any) => {
        test['id'] = test.sequence - 1;
        const testData = simulatedService?.simulatedData?.content?.filter(
          (item: any) => item.operation === test?.operation
        );
        test.testData = testData;
        return test;
      });
      let testDataNames: any = [];
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const workflow =
        workflowList.data?.workflow?.content?.filter((item: any) => item.workflowName === rowData?.serviceNm) || [];
      const operationsList = workflow[0]?.operations;
      const testData = operations?.filter((item: any) => {
        if (item.serviceNm === rowData?.serviceNm) {
          const obj = {
            label: item.testDataName,
            value: item.testDataName
          };
          testDataNames.push(obj);
          return item;
        }
      });
      setFormField(prevState => ({
        ...prevState,
        workflowCode: rowData?.serviceNm,
        testScenarioName: rowData?.testScenarioName,
        description: rowData?.description,
        participantType: rowData?.participantType,
        items: testStepSequences,
        isEdit: true,
        scenarioOperations: operationsList,
        scenarioTestDataNames: testDataNames
      }));
    }
    setFormField(prevState => ({ ...prevState, addScenarioOpen: !addScenarioOpen }));
  };

  const handleFormFields = ({ target: { name, value } }: any) => {
    if (name === 'workflowCode') {
      setFormField(prevState => ({
        ...prevState,
        items: [],
        scenarioOperations: [],
        scenarioTestDataNames: []
      }));
      const workflow = workflowList.data?.workflow?.content?.filter((item: any) => item.workflowName === value) || [];
      const operationsList = workflow[0].operations;
      const testDataList = testDataNames?.filter((item: any) => item.serviceNm === workflow[0]?.workflowName);
      setFormField(prevState => ({
        ...prevState,
        scenarioOperations: operationsList,
        scenarioTestDataNames: testDataList
      }));
    }
    setFormField(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const addStep = () => {
    const obj = {
      operation: '',
      testDataName: '',
      testStepName: '',
      id: items.length,
      testData: []
    };
    const steps = [...items, obj];
    setFormField(prevState => ({ ...prevState, items: steps }));
  };

  const deleteScenarioItem = () => {
    const payload = scenarios.filter((item: any) => item.testScenarioName !== scenario?.testScenarioName);
    const deleteObj = [
      {
        testScenarioName: scenario?.testScenarioName,
        serviceNm: scenario.serviceNm,
        participantType: scenario.participantType
      }
    ];
    deleteScenario({ variables: { payload: deleteObj } })
      .then((res: any) => {
        enqueueSnackbar('Test Scenario deleted successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        setFormField(prevState => ({
          ...prevState,
          scenarios: payload,
          scenario: initialState.scenario,
          isDeleteOpen: !isDeleteOpen
        }));
      })
      .catch(error => {
        enqueueSnackbar('Unable to delete', { variant: 'error', preventDuplicate: true });
      });
  };
  const saveScenario = () => {
    const testStepSequence = items?.map((item: any) => {
      return {
        testScenarioName,
        serviceNm: workflowCode,
        operation: item?.operation,
        testDataName: item?.testDataName,
        testStepName: item?.testStepName,
        sequence: item?.id + 1
      };
    });
    const payload = {
      testScenarioName,
      description,
      serviceNm: workflowCode,
      participantType: participantType,
      testStepSequence
    };

    testScenario({ variables: { payload, method: isEdit ? 'PUT' : 'POST' } })
      .then((res: any) => {
        enqueueSnackbar('Test Scenario added successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        testScenario({ variables: { method: 'GET' } }).then((res: any) => {
          setFormField(prevState => ({
            ...prevState,
            ...initialState,
            operations,
            testDataNames,
            scenarios: res?.data?.testScenario
          }));
        });
      })
      .catch(error => {
        enqueueSnackbar('Unable to save', { variant: 'error', preventDuplicate: true });
      });
  };

  const deleteList = (id: any) => {
    const list = items.filter((item: any) => item.id !== id);
    setFormField(prevState => ({ ...prevState, items: list }));
  };

  const handleItemChange = (e: any, id: any) => {
    const { name, value } = e.target;
    let testData: any = [];
    if (name === 'operation') {
      testData = simulatedService?.simulatedData?.content?.filter((item: any) => item.operation === value);
    }
    items?.map((item: any) => {
      if (item.id === id) {
        item[name] = value;
        if (testData?.length > 0) item.testData = testData;
      }
    });
    setFormField(prevState => ({ ...prevState, items }));
  };

  return (
    <>
      <DetailedTable
        key="scenarioInfo"
        id="scenarioGrid"
        title="Scenario"
        columns={testScenariocolumns}
        data={scenarios}
        tableActions={scenarioTableActions}
        showPagination
        showTopPagination
        showSpecificPage
        // count={scenarios?.totalElements}
        // rowsPerPage={scenarios?.size}
        page={0}
      />
      <DialogForm
        openFn={addScenarioOpen}
        dataConfig={[]}
        handleDialogClose={() =>
          setFormField(prevState => ({
            ...prevState,
            ...initialState,
            scenarios,
            operations,
            testDataNames
          }))
        }
        handleDialogSubmit={saveScenario}
        submitlabel={'Save'}
        // disableSubmitButton={!items.length}
        title={`Add Scenario`}
        dialogId="save-field-id"
        closeFn={() =>
          setFormField(prevState => ({
            ...prevState,
            addScenarioOpen: !addScenarioOpen,
            scenarios,
            operations,
            testDataNames
          }))
        }
        maxWidth="lg"
      >
        <Grid container style={{ padding: '1%' }}>
          <Grid item xs={4}>
            <InputLabel id="WorkflowCode-label">Workflow Code</InputLabel>
            <Select
              id="Select-WorkflowCode"
              data-id="Select-WorkflowCode"
              name="workflowCode"
              onChange={handleFormFields}
              value={workflowCode}
              className={classes.select}
            >
              {workflowList.data?.workflow?.content?.map((service: any) => (
                <MenuItem value={service.workflowName}>{service.workflowName}</MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={3}>
            <InputLabel id="operationCode-label">Test Scenario Name</InputLabel>
            <TextField
              data-id="testScenarioName-input"
              id="testScenarioName"
              name="testScenarioName"
              value={testScenarioName}
              onChange={handleFormFields}
              style={{ width: '80%' }}
              required
            ></TextField>
          </Grid>
          <Grid item xs={4}>
            <InputLabel id="operationCode-label">Description</InputLabel>
            <TextField
              data-id="description-input"
              id="description"
              name="description"
              value={description}
              onChange={handleFormFields}
              style={{ width: '80%' }}
              required
            ></TextField>
          </Grid>
          {/* <Grid item xs={3}>
            <InputLabel id="participantType-label">Participant Type</InputLabel>
            <Select
              id="Select-participantType"
              data-id="Select-participantType"
              name="participantType"
              onChange={handleFormFields}
              value={participantType}
              className={classes.select}
            >
              {participantTypes?.map((participant: any) => (
                <MenuItem value={participant.value}>{participant.label}</MenuItem>
              ))}
            </Select>
          </Grid> */}
          <Grid item xs={1}>
            {workflowCode && testScenarioName && (
              <PlusCircle data-id="add-Button" onClick={addStep} style={{ cursor: 'pointer' }} />
            )}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={10}>
            {items?.length > 0 && (
              <RLDD
                items={items}
                itemRenderer={(item: any, index: any) => (
                  <Grid container className={classes.stepList}>
                    <Grid item xs={2}>
                      <InputLabel id="WorkflowCode-label">Sequence</InputLabel>
                      <p>{index + 1}</p>
                    </Grid>
                    <Grid item xs={3}>
                      <InputLabel id="WorkflowCode-label">Operation Name</InputLabel>
                      <Select
                        id="Select-WorkflowCode"
                        data-id="Select-WorkflowCode"
                        name="operation"
                        onChange={e => handleItemChange(e, item?.id)}
                        value={item?.operation}
                        className={classes.select}
                      >
                        {scenarioOperations?.map((operation: any) => (
                          <MenuItem value={operation.operationName}>{operation.operationName}</MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={3}>
                      <InputLabel id="WorkflowCode-label">Test Data Name</InputLabel>
                      <Select
                        id="Select-WorkflowCode"
                        data-id="Select-WorkflowCode"
                        name="testDataName"
                        onChange={e => handleItemChange(e, item?.id)}
                        value={item?.testDataName}
                        className={classes.select}
                      >
                        {item?.testData?.map((testData: any) => (
                          <MenuItem value={testData.testDataName}>{testData.testDataName}</MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={3}>
                      <InputLabel id="participantType-label">Test Step Name</InputLabel>
                      <TextField
                        inputRef={inputRef}
                        data-id="testStepName-input"
                        id="testStepName"
                        name="testStepName"
                        value={item?.testStepName}
                        onClick={() => {
                          inputRef?.current?.focus();
                        }}
                        onChange={e => handleItemChange(e, item?.id)}
                        style={{ width: '80%' }}
                      ></TextField>
                    </Grid>
                    <Grid item xs={1}>
                      <Trash data-id="delete-step" onClick={() => deleteList(item.id)} />
                    </Grid>
                  </Grid>
                )}
                onChange={(newItem: any) => setFormField(prevState => ({ ...prevState, items: newItem }))}
              />
            )}
          </Grid>
        </Grid>
      </DialogForm>
      <DialogForm
        openFn={isDeleteOpen}
        dataConfig={[]}
        handleDialogClose={() => setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen }))}
        handleDialogSubmit={deleteScenarioItem}
        submitlabel={'Delete'}
        title={`Delete Scenario`}
        dialogId="delete-cenario-id"
        closeFn={() => setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen }))}
        maxWidth="sm"
      >
        <Typography color="textPrimary">
          Are you sure want to delete <b>{scenario?.testScenarioName} ?</b>
        </Typography>
      </DialogForm>
      <ExecuteScenario
        stepExecuteModalOpen={stepExecuteModalOpen}
        setFormField={setFormField}
        rowData={rowData}
        executionData={executionData}
        workflowList={workflowList}
        participant={participant}
        testScenarioExecutionSeq={testScenarioExecutionSeq}
        activeInex={activeInex}
        fields={fields}
        simulationTestData={simulationTestData}
        step={step}
        getExecutionData={getExecutionData}
        loadingTestData={loadingTestData}
        loadingExecutionData={loadingExecutionData}
      />
    </>
  );
};

export default CertificationTestScenario;
